export default __webpack_public_path__ + "static/media/warning--turn-left--g3.f55b92bb.png";